export const DEFAULT_PER_PAGE = 50;
export const DEFAULT_FIRST_PAGE = 1;
